import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Target, Users, Lightbulb, Award } from 'lucide-react';
import content from '../data/content.json';

const iconMap = {
  Target: Target,
  Users: Users,
  Lightbulb: Lightbulb,
  Award: Award
};

const About = () => {
  const { hero, mission, vision, values, whyChooseUs, cta } = content.about;

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="pad-2xl">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="heading-1 mb-6">
              {hero.title}
              <span className="block" style={{ color: 'var(--accent-text)' }}>
                {hero.titleHighlight}
              </span>
            </h1>
            <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
              {hero.subtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="pad-2xl" style={{ background: 'var(--bg-section)' }}>
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12">
              <div className="product-card">
                <h2 className="heading-2 mb-4" style={{ color: 'var(--accent-text)' }}>{mission.title}</h2>
                <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
                  {mission.description}
                </p>
              </div>
              
              <div className="product-card">
                <h2 className="heading-2 mb-4" style={{ color: 'var(--accent-text)' }}>{vision.title}</h2>
                <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
                  {vision.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="pad-2xl">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="heading-2 mb-4">{values.title}</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              {values.subtitle}
            </p>
          </div>
          
          <div className="ai-grid">
            {values.items.map((value, index) => {
              const IconComponent = iconMap[value.icon];
              return (
                <div key={index} className="product-card text-center">
                  <div className="flex justify-center mb-4">
                    <IconComponent className="h-8 w-8" style={{ color: 'var(--accent-text)' }} />
                  </div>
                  <h3 className="heading-3 mb-3">{value.title}</h3>
                  <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="pad-2xl" style={{ background: 'var(--bg-section)' }}>
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="heading-2 mb-6">{whyChooseUs.title}</h2>
            
            <div className="space-y-6 text-left">
              {whyChooseUs.reasons.map((reason, index) => (
                <div key={index} className="flex gap-4">
                  <div className="w-6 h-6 rounded-full flex-shrink-0 mt-1" style={{ background: 'var(--accent-primary)' }}></div>
                  <div>
                    <h3 className="heading-3 mb-2">{reason.title}</h3>
                    <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                      {reason.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="pad-2xl">
        <div className="container">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="heading-2 mb-4">{cta.title}</h2>
            <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
              {cta.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/free-audit" className="btn-orange">
                {cta.primaryCta}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
              <Link to="/services" className="btn-secondary">
                {cta.secondaryCta}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
